/**
 * @generated SignedSource<<12b10f153475c2df408f5f2aab4ae232>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActiveProjectsFilter_responseScales$data = ReadonlyArray<{
  readonly originalId: string;
  readonly responseOptions: ReadonlyArray<{
    readonly label: string | null | undefined;
    readonly value: number;
  }>;
  readonly " $fragmentType": "ActiveProjectsFilter_responseScales";
}>;
export type ActiveProjectsFilter_responseScales$key = ReadonlyArray<{
  readonly " $data"?: ActiveProjectsFilter_responseScales$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActiveProjectsFilter_responseScales">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ActiveProjectsFilter_responseScales",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResponseOption",
      "kind": "LinkedField",
      "name": "responseOptions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ResponseScale",
  "abstractKey": null
};

(node as any).hash = "45caca7b1531a0f948adea161993aee5";

export default node;
